import { Routes } from '@angular/router';

export const routePaths = {
    Home: '',
    Success: 'success',
};

export const routes: Routes = [
    {
        path: routePaths.Home,
        loadComponent: () => import('../modules/main-form/main-form.component').then((m) => m.MainFormComponent),
    },
    {
        path: routePaths.Success,
        loadComponent: () => import('../modules/success/success.component').then((m) => m.SuccessComponent),
    },
];
